export const TEAM = [
    {
      nombre: 'Elmer Salas Capuccino',
      cargo: 'Chief Executive Officer (CEO)',
      linkedin: '/assets/images/linkedin.webp',
      imagen: 'assets/images/equipo.png'
    },
    {
      nombre: 'Marta García Pérez',
      cargo: 'Chief Marketing Officer (CMO)',
      linkedin: 'assets/images/linkedin.webp',
      imagen: 'assets/images/equipo.png'
    },
    {
      nombre: 'Carlos López Fernández',
      cargo: 'Chief Financial Officer (CFO)',
      linkedin: 'assets/images/linkedin.webp',
      imagen: 'assets/images/equipo.png'
    },
    {
      nombre: 'Ana Martínez López',
      cargo: 'Chief Operating Officer (COO)',
      linkedin: 'assets/images/linkedin.webp',
      imagen: 'assets/images/equipo.png'
    }
];
